export default __webpack_public_path__ + "static/media/placeholder_search_instructions_dark.a446aa04.svg";